// import { auth, googleProvider, twitterProvider, facebookProvider } from '../firebase';
import axios from "axios";
import * as actionTypes from "../actionTypes";
import { deleteFcmTokenData } from "../CommonFunctions";
import firebase, { database } from "../firebase";
import * as constants from "../Constatnts";

export function getUserACL(uid) {
  return async (dispatch) => {
    let addMessage = firebase.functions().httpsCallable("getUserACL");
    return addMessage().then(function(result) {
      let acl = result.data.text;
      //let acl = getUserACLTmp(uid);
      dispatch({ type: actionTypes.SET_ACL, acl });
    });
  };
}








export function getAllStores(registrationID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/stores/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.stores;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


function checkUserACLInLocalStorage() {
  let acl = JSON.parse(localStorage.getItem("acl"));
  console.log("checkUserACLInLocalStorage", acl);
  if (acl) {
    return acl;
  } else {
    return null;
  }
}

function setUserACLInLocalStorage(acl) {
  console.log("setUserACLInLocalStorage", acl);
  localStorage.setItem("acl", JSON.stringify(acl));
}

export function updateUser(user) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
     const response = await axios.put(
        `${constants.API_URL}/user/updateuser/${user.key}`,
        user,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
      return  response.data.data;
      }
      else{
        return false;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function setAuthUser(auth) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_AUTH, auth });
  };
}

export function setUAT(uat) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_UAT, uat });
  };
}

export function signOutUser() {
  return async (dispatch) => {
    await deleteFcmTokenData();

    dispatch({
      type: actionTypes.SIGN_OUT,
    });
  };
}

// export function getUserDetails(uid, login = false)
// {
//     return (dispatch) => {
//         console.log('uid',uid)
//         return database.collection("User").where("UID","==", uid).get().then((querySnapshot) => {
//             return querySnapshot.forEach((doc) => {
//                 const user =  doc.data();
//                 console.log('user',user)
//                 dispatch({type:actionTypes.SET_USER, user })
//                 // {id, EmailID , Name, RegistrationID, UID}=
//            })
//         }).catch((error) => {
//             console.log(error)
//         })
//     }
// }

export function getUserDetails(UID, login = false) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/user/getuserdetails?uid=${UID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      let user = response.data.data[0];

      if (user) {
        user = {
          key: user.id,
          ...user,
        };

        delete user.id;
      }

      if (login) {
        dispatch({ type: actionTypes.SET_USER, user });
      } else {
        return user;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


function checkUserInLocalStorage(UID) {
  //return null;
  let user = JSON.parse(localStorage.getItem("user"));
  console.log("checkUserInLocalStorage", user);
  if (user && user.UID === UID) {
    return user;
  } else {
    return null;
  }
}

function setUserInLocalStorage(user) {
  console.log("setUserInLocalStorage", user);
  localStorage.setItem("user", JSON.stringify(user));
}


export function  createUser(user)  {
  return async (dispatch, getState) => {
    try {
      console.log("user",user);
      const token = getState().user.uat;
     const response = await axios.post(
        `${constants.API_URL}/user/createuser`,
        user,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
      return  response.data.user.id;
      }
      else{
        return false;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function setStore(store) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_STORE, store });
  };
}

export function setHasAccessToMultipleStores(hasAccessToMultipleStores) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_HAS_ACCESS_TO_MULTIPLE_STORES,
      hasAccessToMultipleStores,
    });
  };
}

function setStoreInLocalStorage(store) {
  console.log("setStoreInLocalStorage", store);
  localStorage.setItem("store", JSON.stringify(store));
}

export function setCashRegister(cashRegister) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_CASH_REGISTER, cashRegister });
  };
}

export function setCashRegisterClosing(cashRegisterClosing) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_CASH_REGISTER_CLOSING,
      cashRegisterClosing,
    });
  };
}
